<template>
    <form autocomplete="off" class="">
        <div class="row gy-3">
            <div class="col-12">
                <label>What is the purpose? <span class="text-danger small">*</span></label>
                <input type="text" v-model="data.title" placeholder="Purpose" 
                    :class="{ 'is-invalid': v$.data.title.$error }" class="form-control" />
                <div v-for="(item, index) in v$.data.title.$errors" :key="index"
                    class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>   
            <div class="col-12">
                <div class="d-flex mt-3 justify-content-end">
                    <b-button variant="primary" 
                    @click.prevent="create()"
                     type="button">Submit</b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
    },
    data(){
        return{
            data: {
                title:"",
            },
        }
    },
    validations() {
        return {        
            data:{
                title: { 
                    required: helpers.withMessage("Purpose is required", required)
                },           
            },

        }
    },
    methods:{
        create() {
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };
                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post('/access-codes/create', this.data)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('addedItem', response.data.data)
                        this.resetForm();
                    }
                })
            })
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        }
    },
    mounted(){
    }
}
</script>